import {createSelector} from "@reduxjs/toolkit";
import {State} from "../../../store";
import useSelector from "../../common/hooks/useSelector";
import UsersState from "../types/UsersState";

export default function useUsersSelector<TSelected>(selector: (state: UsersState) => TSelected, equalityFn?: (left: TSelected, right: TSelected) => boolean): TSelected {
    const reselect = createSelector((state: State) => state.users, selector);
    return useSelector(reselect, equalityFn);
}